import "./App.css";
import "bootstrap/dist/css/bootstrap.css";
import Weather from "./Weather";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultCity="Lisbon" />
        <footer>
          Open-source coded on{" "}
          <a
            href="https://github.com/cherigit/weather-react-final"
            target="_blank"
            rel="noreferrer"
          >
            Github
          </a>{" "}
          and hosted at{" "}
          <a
            href="https://joyful-lollipop-ab21d6.netlify.app/"
            target="_blank"
            rel="noreferrer"
          >
            Netify
          </a>{" "}
          by Cheri Lee
        </footer>
      </div>
    </div>
  );
}
